export function splitHover(el) {
    el.classList.add('split-hover')
    const textContent = el.textContent
    el.innerHTML = `<span class="line line-normal">${textContent}</span><span class="line line-hover">${textContent}</span>`
}